console.log("scrolling.js loaded");

console.log("scrolling.js loaded");

const lenis = new Lenis({
  duration: 1.2,
  smooth: true
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);


window.addEventListener("scroll", () => {
  const banner = document.querySelector(".banner");
  const image = document.querySelector(".banner__media img");

  if (!banner || !image) return;

  const rect = banner.getBoundingClientRect();
  const speed = 0.07;

  if (rect.top < window.innerHeight && rect.bottom > 0) {
    const offset = -rect.top * speed;
    image.style.transform = `translateY(${offset}px) scale(1.0)`;
  }
});



document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header-wrapper");

  if (!header) return;

  window.addEventListener("scroll", function () {
    if (window.scrollY > 10) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll('.animate-on-scroll');

  if (!elements.length) return;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('show');
        observer.unobserve(entry.target); // animate only once
      }
    });
  }, {
    threshold: 0.5
  });

  elements.forEach(el => observer.observe(el));
});